import { render } from "./SeasonList.vue?vue&type=template&id=2b739c42&bindings={}"
import script from "./SeasonList.vue?vue&type=script&lang=ts"
export * from "./SeasonList.vue?vue&type=script&lang=ts"
script.render = render

export default script